// frontend/src/samkalp-admin/panels/AnalyticsPanel.js
import React from 'react';
import TenantSubscriptionAnalytics from '../../components/TenantAdmin/TenantSubscriptionAnalytics';

const AnalyticsPanel = ({ slug }) => (
    <TenantSubscriptionAnalytics tenantSlug={slug} />
);

export default AnalyticsPanel;
